export default __webpack_public_path__ + "static/media/Comment-sent.084c7278.svg";